import { render, staticRenderFns } from "./screening-statistics-dialog.vue?vue&type=template&id=7206f7c4&scoped=true"
import script from "./screening-statistics-dialog.vue?vue&type=script&lang=js"
export * from "./screening-statistics-dialog.vue?vue&type=script&lang=js"
import style0 from "./screening-statistics-dialog.vue?vue&type=style&index=0&id=7206f7c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7206f7c4",
  null
  
)

export default component.exports